export default {
  plural: 'Colors',
  singular: 'Color',
  attach: 'Attach colors',
  colorSwatch: 'Color swatch'
};
